export default "__VITE_PUBLIC_ASSET__bb99e6ef__"